export enum PaymentMethods {
  CC = 'payment_card',
  POA = 'pay_on_arrival',
}
